<template> 
  <div class="container">  
    
    <!-- Modal Fotos -->
    <transition v-if="showModalFotos" id="fotos" name="fotos">
      <div class="modal-cus-mask">
        <div class="modal-cus-wrapper">
          <div class="modal-cus-container">

            <div class="modal-cus-header">
              <slot name="header">
                <div class="title-boreder">
                <div class="box-title box-title-sub">
                <img src="/static/img/svg/photo.svg" style="padding-bottom: 6px; padding-right: 8px;"> <span>ver fotos</span>
                </div>
                <button type="button" class="close" v-on:click="showModalFotos = false" style="padding:5px;position: relative !important; top: -35px !important;" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              </slot>
            </div>

            <div class="modal-cus-body">
              <slot name="body">
                <div class="slideshow-container-ora">
                  <div class="slides-ora fade-ora" v-for="(foto, fotosIndex) in fotos" :key="fotosIndex">  
                    <button type="button" class="close" @click="download(foto)">
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </button>                                          
                    <inner-image-zoom :src="foto" :zoomSrc="foto" />
                  </div>
<!--
                  <a class="prev-ora" v-on:click="plusSlides(-1)">❮</a>
                  <a class="next-ora" v-on:click="plusSlides(1)">❯</a>                  
-->                  
                </div>
                <br>
                <div style="text-align:center">
                  <span class="dot-ora" v-for="(foto, fotosIndex) in fotos" :key="fotosIndex" v-on:click="currentSlide(fotosIndex + 1)"></span>
                </div>
              </slot>
            </div>            
          </div>
        </div>
      </div>
    </transition>
    <!-- Fin Modal -->    

    
    <!-- Modal Copiar -->
    <transition v-if="showModalCopiar" id="copiar" name="copiar">      
      <div class="modal-cus-mask">        
        <div class="modal-cus-wrapper">
          <div class="modal-cus-container"  style="width:450px">

            <div class="modal-cus-header">
              <slot name="header">
                <div class="title-boreder">
                <div class="box-title box-title-sub">
                  <span>Enviar Vínculo</span>
                </div>
                <button type="button" class="close" v-on:click="showModalCopiar = false" style="padding:5px;position: relative !important; top: -35px !important;" >
                  <span aria-hidden="true">&times;</span>
                </button>                
              </div>
              </slot>
            </div>
            <div class="modal-cus-body" style="margin:10px">
              <slot name="body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-lg-1 col-md-1 col-xs-2" style="    font-size: 24px; padding-top: 15px; color: #3D77FF;">
                        <i class="fa fa-link a-icon" aria-hidden="true" ref="atrack"></i>
                      </div>
                      <div class="col-lg-8 col-md-8 col-xs-10 text-left">
                        Comparte el seguimiento de tu pedido, pídele a la otra persona que ingrese tu nombre para ver el tracking
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12 text-center">
                        <button type="button" class="btn btn-ora-blue" @click="copy()">
                          Copiar
                        </button>
                        <div id="divCopy" class="div-copy" style="display: none;">Copiado</div>
                      </div>
                    </div>
                  </div>
                </div>
              </slot>
            </div>            
          </div>
        </div>
      </div>
    </transition>
    <!-- Fin Modal -->    

    <!-- Modal Detalle -->
    <modal id="detail" name="detail" class="modal-ora">
      <div class="box-header title-boreder">
        <div class="box-title box-title-sub">
         <img src="/static/img/svg/list.svg" style="padding-bottom: 6px; padding-right: 8px;"> <span>Detalle de Pedido</span>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="$modal.hide('detail')" style="padding:5px;" >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="filterContainer">
        <vuetable v-if="!mobile"
          id="resultTable"
          ref="vuetable"
          :api-mode="false"
          :fields="tableFields"
          :css="tableCSS.table"
          noDataTemplate="No se encontraron resultados"
          :data="tableData"                    
          :key="tableKey">
          <template slot="itemPos" scope="props">
            <div class="text-right" >
              {{ props.rowData.itemPos}}
            </div>
          </template>
          <template slot="lpn" scope="props">
            <div>
              <span >{{props.rowData.lpn}}</span>
            </div>
          </template>
          <template slot="itemCode" scope="props">
            <div>
              {{props.rowData.itemCode}}
            </div>
          </template>
          <template slot="itemDescription" scope="props">
            <div>
              {{props.rowData.itemDescription}}
            </div>
          </template>
          <template slot="quantityOrder" scope="props">
            <div class="text-center">
              {{props.rowData.quantityOrder}}
            </div>
          </template>
          <template slot="quantitySent" scope="props">
            <div class="text-center">
              {{props.rowData.quantitySent}}
            </div>
          </template>                  
          <template slot="quantityDelivered" scope="props">
            <div class="text-center">
              {{ props.rowData.quantityDelivered }}
            </div>
          </template>                 
          <template slot="quantityRejected" scope="props">
            <div class="text-center">
              {{ props.rowData.quantityRejected }}
            </div>
          </template>
        </vuetable>    
        <div class="col-12" v-else>
          <div  v-for="(detail, index) in this.tableData.data" :key="index">
            <div class="row">
              <div class="col-xs-6"><span class="data-field">Nro</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.itemPos }}</span></div>
            </div>
            <div class="row">
              <div class="col-xs-6"><span class="data-field">LPN / Precintos</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.lpn }}</span></div>
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Código SKU</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.itemCode }}</span></div>
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Descripción SKU</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.itemDescription }}</span></div>
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Cant. Pedido</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.quantityOrder }}</span></div>
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Cant. Despachada</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.quantitySent }}</span></div> 
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Cant. Entregada</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.quantityDelivered }}</span></div> 
            </div>
            <div class="row">              
              <div class="col-xs-6"><span class="data-field">Cant. Rechazada</span></div>
              <div class="col-xs-6" :style="{background: index % 2 === 0 ? 'white' : '#FAFBFF' }"><span class="data-title">{{ detail.quantityRejected }}</span></div>                                                                                            
            </div>
            <br/>
          </div>
        </div>                                        
      </div>      
    </modal>
    <!-- Fin Modal -->        
    
    <div :class="isOrder ? 'container-order' : 'container-tra'">
      <div :class="isOrder ? 'nav-tra-order' : 'nav-tra'">
        <img :src="`data:image/png;base64,${order.accountLogo}`" class="ico-account" v-if="existe && order.accountLogo != null && isOrder" />
        <img src="/static/img/logo-tra.png" style="height:30px" v-if="!isOrder" />
        <img :src="`data:image/png;base64,${order.accountLogo}`" style="height:35px" v-if="existe && order.accountLogo != null && !isOrder" />
      </div>        
      <div class="col" v-if="existe == 1">
        <div class="row row-button" v-if="order.realTimeFlag == 1">                            
          <span class="ub-actual" @click.prevent="getPoint()">
            <img src="/static/img/svg/pointer.svg" class="ub-icon" />
            <span v-if="!mobile">Ver ubicación actual</span>
          </span>               
        </div>

        <l-map v-if="isPoint" :zoom="zoom" :center="center" style="width:100%;  height: 400px;">
          <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />                     
          <l-marker :lat-lng="center">
            <l-icon :icon-url="iconGP" :icon-size="[iconHE, iconWI]" :icon-anchor="[iconHE,iconWI]" />            
          </l-marker>
        </l-map>

        <div style="height: 70px;" v-if="!isPoint && !isOrder">
        </div>
        <!-- Modo Browser -->
        <div class="row" v-if="!mobile">
            <div class="col-xs-1"></div>
            <div class="col-xs-12 col-md-10">
              <div :class="isPoint ? 'box-tra' : 'box-tra-sm'">
                <div class="col-md-12">
                  <div class="row div-ora-flex">
                    <div class="col-md-6 img-back">
                      <img src="/static/img/svg/arrow-left.svg" style="cursor:pointer;padding-right: 5px;" @click="$emit('hiddenTrack', false)" v-if="showBack" />
                      <div class="label-bold-tra">N° Pedido : {{ order.customerOrderNumber == null ? order.orderNumber : order.customerOrderNumber }}</div>
                    </div>
                    <div class="col-md-6 text-right">
                      <button class="btn btn-ora-blue" @click="showDetail()" v-if="isOrder">Ver Detalle</button>
                    </div>                    
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-lg-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="card-tra">
                            <div class="card-header-tra">
                              <div>
                                <span class="icon-tracking"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                <span class="label-bold-tra">Tracking</span>
                              </div>
                              <div>
                                <span class="status" :style="{background: order.configuration.minTextFundColor == '' ? 'black' : order.configuration.minTextFundColor, color: order.configuration.minTextColor == '' ? 'white' : order.configuration.minTextColor }">{{ order.statusDescription | firstLetter }}</span>                        
                              </div>
                            </div>
                            <div class="timeline">
                              <div class="outer">
                                <div class="card-tl" v-for="(event, index) in eventList" :key="index">
                                  <div class="info">
                                    <div class="card-lt-title"><span>{{ (event.reason == '' ? event.event : event.reason) | capitalize }}</span><a class="arrow-tra" data-toggle="collapse" :href="`#col${index}`"  v-if="event.existImage"><i class="fa fa-chevron-down" aria-hidden="true"></i></a></div>
                                    <p class="p-tra">
                                      {{ event.eventDate | formatDate("LLL")}}
                                      <br/>
                                      <span v-if="event.location != '' && event.location.trim() != '-'">{{ event.location | firstLetter}}</span>
                                    </p>                                    
                                    <div :id="`col${index}`" class="panel-collapse collapse" style="padding-bottom: 10px;">
                                      <img :src="`${event.imageUrl1}`" class="img-event" v-if="event.imageUrl1 != ''" @click="modalFotos(event, 0)" />
                                      <img :src="`${event.imageUrl2}`" class="img-event" v-if="event.imageUrl2 != ''" @click="modalFotos(event, 1)" />
                                      <img :src="`${event.imageUrl3}`" class="img-event" v-if="event.imageUrl3 != ''" @click="modalFotos(event, 2)" />                                     
                                    </div>
                                  </div>
                                </div>                        
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                      
                    </div>
                    <div class="col-xs-12 col-sm-6 col-lg-6">
                      <div class="row"  v-if="!mobile">
                        <div class="col-md-12" v-if="!isOrder">
                          <div class="msg-tra" :style="{background: order.configuration.fundColor }">
                            <div style="    display: flex; justify-content: space-between;">
                              <div>   
                                <div class=" msg-icono" :style="{background: order.configuration.iconFundColor }">
                                  <img :src="`data:image/png;base64,${order.configuration.icon}`" class="msg-img" />
                                </div>                                
                              </div>
                              <div style="width:100%">
                                <div class="msg-title" :style="{color: order.configuration.higherTextColor }">Hola, {{ order.customerName | firstLetter }}</div>
                                <p class="msg-p" :style="{color: order.configuration.lowerTextColor }">Tu pedido tiene un estado de {{ order.statusDescription  | minus }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="card-tra">
                            <div class="card-header-tra">
                              <div>                                
                                <span class="icon-tracking"><img src="/static/img/svg/document.svg" class="icon-tracking-img" /></span>
                                <span class="label-bold-tra">Información del Pedido</span>
                              </div>
                              <div>
                                <span><a rel="noopener noreferrer" @click="showModalCopiar = true" class="a-tra"><i class="fa fa-link a-icon" aria-hidden="true" ref="atrack"></i>Compartir Pedido</a></span>
                              </div>
                            </div>
                            <div class="card-body-tra">
                              <div class="row data-space">
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/document.svg" /></span>
                                  <span class="data-title">Tracking del Pedido</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/document.svg" /></span>
                                  <span class="data-title">Número del Pedido</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">                                  
                                  <span class="data-field">{{ this.order.tracking }}</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">                                  
                                  <span class="data-field">{{ order.customerOrderNumber == null ?  order.orderNumber :  order.customerOrderNumber }}</span>
                                </div>                          
                              </div>
                              <div class="row data-space">
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/user.svg" /></span>
                                  <span class="data-title">Cliente</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/phone.svg" /></span>
                                  <span class="data-title">Número de Celular</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <label class="data-field" style="margin-top: 4px;">{{ this.order.customerName | firstLetter }}</label>                                  
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-field">{{ order.destinyContactPhone }}</span>
                                </div>                          
                              </div>
                              <div class="row data-space">
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/location.svg" style="width: 16px;" /></span>
                                  <span class="data-title">Dirección de origen</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">
                                  <span class="data-icon"><img src="/static/img/svg/destiny.svg" /></span>
                                  <span class="data-title">Dirección de entrega</span>
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">                            
                                  <label class="data-field" style="margin-top: 4px;">{{ this.order.sourceAddress | firstLetter }} <br/>{{ this.order.sourceNameUbigeo | firstLetter }} </label>                                  
                                </div>
                                <div class="col-xs-12 col-md-6 col-lg-6">                            
                                  <label class="data-field" style="margin-top: 4px;">{{ order.destinyAddress | firstLetter }} <br/> {{ this.order.destinyNameUbigeo | firstLetter }}</label>                                          
                                </div>                                                                
                              </div>                                                
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="help-tra">
                            <div class="row help-container">
                              <div class="help-icono">
                                <img src="/static/img/help.png" class="help-img" />
                              </div> 
                              <div>                                
                                <div class="help-title">{{ order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : order.helpQuestion.trim() }}</div>
                                <a class="help-p" v-if="order.contactType == 'TELF'" :href="`tel:${order.contactValue}`">Contáctate con nosotros</a>
                                <a class="help-p" v-else-if="order.contactType == 'MAIL'" :href="`mailto:${order.contactValue}`">Contáctate con nosotros</a>
                                <a class="help-p" v-else :href="`${order.contactValue}`" target="_blank">Contáctate con nosotros</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-1" v-if="!mobile"></div>
        </div>
    
        <!-- Modo Mobile -->
        <div class="row" v-if="mobile">
            <div class="col-xs-12"  style="padding-left:0px" v-if="!isOrder">
              <div :class="order.statusDescription.length > 10 ? (isPoint ? 'msg-tra-high' : 'msg-tra-high-vacio') : (isPoint ? 'msg-tra' : 'msg-tra-vacio')" :style="{background: order.configuration.fundColor }">
                <div class="row">
                  <div class="col-xs-2 col-md-3" style="padding-left:0px">   
                    <div class="msg-icono" :style="{color: order.configuration.iconFundColor }">
                      <img :src="`data:image/png;base64,${order.configuration.icon}`" class="msg-img" />
                    </div>                    
                  </div>
                  <div class="col-xs-10 col-md-9" style="padding-left:0px;padding-right:0px">
                    <div class="msg-title" :style="{color: order.configuration.higherTextColor }">Hola, {{ order.customerName | firstLetter }}</div>
                    <p class="msg-p" :style="{color: order.configuration.lowerTextColor }">Tu pedido tiene un estado de {{ order.statusDescription  | minus }}</p>
                  </div>
                </div>
              </div>
            </div>
        </div>   

        <div class="row" v-if="mobile">        
          <div class="col-xs-12" style="padding-left:0px">
                <div :class="isPoint ? 'box-tra' : 'box-tra-sm'">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-xs-12 img-back">
                        <img src="/static/img/svg/arrow-left.svg" @click="$emit('hiddenTrack', false)" v-if="showBack" style="padding-right: 5px;" />
                        <div class="label-bold-tra">N° Pedido : {{ order.customerOrderNumber == null ? order.orderNumber : order.customerOrderNumber }}</div>
                      </div>
                    </div>
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="active">
                        <a role="tab" class="a-tab" data-toggle="tab" @click.prevent="setActive('track')" :class="{ active: isActive('track') }" href="#track" aria-expanded="true">Tracking</a>
                      </li>
                      <li>
                        <a role="tab" class="a-tab" data-toggle="tab" @click.prevent="setActive('info')" :class="{ active: isActive('info') }" href="#info">Información del Pedido</a>
                      </li>         
                    </ul>
                    <div class="tab-content" id="tabTrack">
                      <div class="tab-pane fade active in" :class="{ 'active': isActive('track') }" id="track">
                        <div class="row">
                          <div class="col-xs-12" style="padding-left:0px;padding-right:0px">
                            <div class="row">
                              <div class="col-md-12" style="padding-left:0px;padding-right:0px">                            
                                  <div class="nav-tra">
                                    <div>                                    
                                      <span class="label-bold-tra">Estado</span>
                                    </div>
                                    <div>
                                      <span class="status" :style="{background: order.configuration.minTextFundColor == '' ? 'black' : order.configuration.minTextFundColor, color: order.configuration.minTextColor == '' ? 'white' : order.configuration.minTextColor }">{{ order.statusDescription  | firstLetter }}</span>                        
                                    </div>
                                  </div>

                                  <div class="timeline">
                                    <div class="outer">
                                      <div class="card-tl" v-for="(event, index) in eventList" :key="index">
                                        <div class="info">
                                          <div class="card-lt-title"><span>{{ (event.reason == '' ? event.event : event.reason) | capitalize }}</span><a class="arrow-tra" data-toggle="collapse" :href="`#col${index}`"  v-if="event.existImage"><i class="fa fa-chevron-down" aria-hidden="true"></i></a></div>
                                          <p class="p-tra">{{ event.eventDate | formatDate("LLL")}}
                                            <br/>
                                            <span v-if="event.location != '' && event.location.trim() != '-'">{{ event.location | firstLetter}}</span>
                                          </p>                                          
                                        </div>
                                        <div :id="`col${index}`" class="panel-collapse collapse" style="padding-bottom: 10px;">
                                          <img :src="`${event.imageUrl1}`" class="img-event" v-if="event.imageUrl1 != ''" @click="modalFotos(event, 0)" />
                                          <img :src="`${event.imageUrl2}`" class="img-event" v-if="event.imageUrl2 != ''" @click="modalFotos(event, 1)" />
                                          <img :src="`${event.imageUrl3}`" class="img-event" v-if="event.imageUrl3 != ''" @click="modalFotos(event, 2)" />                                     
                                        </div>                                        
                                      </div>                        
                                    </div>
                                  </div>                             
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="help-tra">
                                  <div class="row help-container">
                                    <div class="help-icono">
                                      <img src="/static/img/help.png" class="help-img" />
                                    </div> 
                                    <div>                                
                                      <div class="help-title">{{ order.helpQuestion.trim() === '' ? '¿Necesitas ayuda con tu pedido?' : order.helpQuestion.trim() }}</div>
                                      <a class="help-p" v-if="order.contactType == 'TELF'" :href="`tel:${order.contactValue}`">Contáctate con nosotros</a>
                                      <a class="help-p" v-else-if="order.contactType == 'MAIL'" :href="`mailto:${order.contactValue}`">Contáctate con nosotros</a>
                                      <a class="help-p" v-else :href="`${order.contactValue}`" target="_blank">Contáctate con nosotros</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" :class="{ 'active': isActive('info') }" id="info">
                        <div class="row" v-if="isOrder">
                          <div class="col-md-12 text-right">
                            <button class="btn btn-ora-blue" style="margin: 15px 0px" @click="showDetail()">Ver Detalle</button>
                          </div>
                        </div>                        
                        <div class="row">
                          <div class="col-md-12" style="padding-left: 0px;padding-right: 0px;">
                            <div class="row data-space">
                              <div class="col-xs-5 col-md-6 col-lg-6 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/document.svg" /></span>
                                <span class="data-title">Tracking Pedido</span>
                              </div>
                              <div class="col-xs-7 col-md-6 col-lg-6 data-mob text-right">                                      
                                <span class="data-field">{{ this.order.tracking }}</span>
                              </div>
                            </div>
                            <div class="row data-space">
                              <div class="col-xs-5 col-md-6 col-lg-6 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/document.svg" /></span>
                                <span class="data-title">Número Pedido</span>
                              </div>
                              <div class="col-xs-7 col-md-6 col-lg-6 data-mob text-right">                                      
                                <span class="data-field">{{ order.customerOrderNumber == null ? order.orderNumber : order.customerOrderNumber }}</span>
                              </div>
                            </div>
                            <div class="row data-space">
                              <div class="col-xs-4 col-md-4 col-lg-4 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/user.svg" /></span>
                                <span class="data-title">Cliente</span>
                              </div>
                              <div class="col-xs-8 col-md-8 col-lg-8 data-mob text-right">                                      
                                <span class="data-field">{{ this.order.customerName | firstLetter }}</span>
                              </div>
                            </div>
                            <div class="row data-space">
                              <div class="col-xs-5 col-md-6 col-lg-6 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/phone.svg" /></span>
                                <span class="data-title">Número Celular</span>
                              </div>
                              <div class="col-xs-7 col-md-6 col-lg-6 data-mob text-right">                                      
                                <span class="data-field">{{ order.destinyContactPhone }}</span>
                              </div>
                            </div>
                            <div class="row data-space-border">
                              <div class="col-xs-5 col-md-6 col-lg-6 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/location.svg" /></span>
                                <span class="data-title">Dirección origen</span>
                              </div>
                              <div class="col-xs-7 col-md-6 col-lg-6 data-mob text-right">                                      
                                <span class="data-field">{{ this.order.sourceAddress | firstLetter }} <br/> {{ this.order.sourceNameUbigeo | firstLetter }}</span>
                              </div>
                            </div>
                            <div class="row data-space-border" style="border-top: 1px solid #DBDFE3; margin-top: 10px;">
                              <div class="col-xs-5 data-mob">
                                <span class="data-icon"><img src="/static/img/svg/destiny.svg" /></span>
                                <span class="data-title">Dirección entrega</span>
                              </div>
                              <div class="col-xs-7 data-mob text-right">                                      
                                <span class="data-field">{{ this.order.destinyAddress | firstLetter }} <br/>{{ this.order.destinyNameUbigeo | firstLetter }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 text-center" style="padding:10px">
                            <span><a rel="noopener noreferrer" @click="showModalCopiar = true" class="a-tra"><i class="fa fa-link a-icon" aria-hidden="true" ref="atrack"></i>Compartir Pedido</a></span>
                          </div>
                        </div>                        
                      </div>          
                    </div>
                  </div>
                </div>
          </div>
        </div>

      </div>

      <div class="msg-order" v-else-if="existe == 2 && !isOrder">
        <div v-if="mobile">
          <img src="/static/img/buscar.png" class="img-bus" />
        </div>        
        <div>
          <div class="title-bus">
            Hola,
          </div>
          <div class="subtitle-bus">
            Bienvenido a Dinet
          </div>            
          <p class="p-bus">
            Para ver el estado de su pedido necesitamos que se identifique:
          </p>
          <p class="p-bus">
              Ingrese tus datos
          </p>
          <form @submit.prevent="search()" autocomplete="off">
            <div class="row">              
              <div class="col-md-12">
                <div class="form-group">                  
                  <input v-model="fName" placeholder="Apellidos y/o Nombres" class="form-control form-control-ora" :class="{ 'is-invalid': submitted && !fName }"/>
                  <div v-show="submitted && fName===''" class="invalid-feedback">Los apellidos y/o nombres es requerido</div>
                </div>
              </div>                                                                                        
            </div>  
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-6">   
                <button v-bind:class="['btn btn-ora', { 'disabled' : (submitted && fName === '') }]" class="" type="submit">Continuar <i class="fa fa-angle-right" aria-hidden="true"></i></button>
              </div>
            </div>  
          </form>                               
        </div>
        <div v-if="!mobile">
          <img src="/static/img/buscar.png" class="img-bus" />
        </div>
      </div>

      <div :class="isOrder ? 'msg-nf-order' : 'msg-nf'" v-else-if="existe == 0">
        <div v-if="mobile">
          <img src="/static/img/noencontrado.png" class="img-nf" />
        </div>        
        <div>
          <div class="title-nf">
            No hemos podido encontrar tu pedido
          </div>
          <p class="p-nf">
            Comunicate con nosotros para brindarte información de tu pedido
          </p>
          <br/>
            <button v-on:click="contact()" class="btn btn-ora" style="width:200px">Contáctate con nosotros</button>          
        </div>
        <div v-if="!mobile">
          <img src="/static/img/noencontrado.png" class="img-nf" />
        </div>
      </div>
    </div>        
  </div>
  
</template>

<script>
import { mapActions } from 'vuex'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'
import { Vuetable } from 'vuetable-2'
import constants from 'assets/js/constants.js'
import InnerImageZoom from 'vue-inner-image-zoom'

import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet'
import { Icon, latLng } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  name: 'TrackingNumber',
  props: ['track', 'showBack', 'firstName', 'document', 'isOrder', 'account', 'orderNumber', 'trackOrder', 'parameters'],
  data () {
    return {
      showModalFotos: false,
      showModalCopiar: false,
      slideIndex: 1,
      loader: null,
      mobile: false,
      existe: -1,
      tracking: '',
      name: '',
      activeItem: 'track',
      iconGP: '/static/img/icons/ic_dinet_48.png',
      iconHE: 36,
      iconWI: 48,
      isPoint: false,
      fName: '',
      doc: '',
      fotos: [],
      order: {},
      eventList: [],
      zoom: null,
      zoomDefault: 17,
      centerDefault: latLng(-12.0889092, -77.0044656),
      center: null,
      markers: [],
      submitted: false,
      tableKey: 1,
      tableData: {
        data: null
      },
      tableFields: [
        {
          name: '__slot:itemPos',
          title: 'Nro.',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:lpn',
          title: 'LPN / Precintos',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:itemCode',
          title: 'Código SKU',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:itemDescription',
          title: 'Descripción SKU',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:quantityOrder',
          title: 'Cant. Pedido',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:quantitySent',
          title: 'Cant. Despachada',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:quantityDelivered',
          title: 'Cant. Entregada',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        },
        {
          name: '__slot:quantityRejected',
          title: 'Cant. Rechazada',
          titleClass: 'table-text-ora',
          dataClass: 'table-data-ora'
        }
      ],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      }
    }
  },
  computed: {
    google: gmapApi
  },
  beforeMount () {
    loadGmapApi({
      key: constants.apiKeyGoogle.b2c
    })
  },
  created () {
    this.tableCSS = constants.tableCSSOra
    this.mobile = this.isMobile()
    this.zoom = this.mobile ? this.zoomDefault - 1 : this.zoomDefault
    this.center = this.centerDefault
    this.existe = 2
    this.isPoint = false

    if (this.track === undefined) {
      this.tracking = this.$route.params.tracking
      this.name = this.$route.params.name
      if (this.name !== undefined && this.name !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        let filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.name,
          CustomerDNI: ''
        }

        this.getTracking(filter).then((response) => {
          this.loader.hide()

          if (response.order != null) {
            this.setOrder(response.order)
          } else if (response.errorCode > 0) {
            this.existe = 0
          }
        })
      }
    } else {
      this.tracking = this.track
      if (this.tracking !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        let filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.firstName,
          CustomerDNI: this.document
        }

        this.getTracking(filter).then((response) => {
          this.loader.hide()

          if (response.order != null) {
            this.setOrder(response.order)
          } else if (response.errorCode > 0) {
            this.existe = 0
          }
        })

        if (this.isOrder) {
          this.getDetail()
        }
      } else {
        this.existe = 0
      }
    }

    window.onpopstate = () => {
      if (this.isOrder) {
        this.$router.push({ name: 'EcommerceSearchDocuments', params: this.parameters })
      } else {
        this.$router.push({ name: 'TrackingOrder', params: { order: this.trackOrder, name: this.name } })
      }
    }
  },
  methods: {
    ...mapActions([
      'getTracking',
      'getPointTracking',
      'getOrderFollowDetail'
    ]),
    copy () {
      var currentUrl = window.location.origin + '/Tracking/' + this.tracking
      const el = document.createElement('textarea')
      el.value = currentUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      $('#divCopy').show()
      $('#divCopy').fadeOut(2000)
    },
    isMobile () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    modalFotos (event, index) {
      this.fotos = []
      event.fotos.forEach(x => {
        // this.fotos.push('data:image/png;base64,' + x)
        this.fotos.push(x)
      })
      this.showModalFotos = true
      this.slideIndex = index + 1
      let self = this
      setTimeout(function () {
        let widthModal = $(window).width() - 165
        let heightBody = $(window).height() - 125
        let heightCarousel = $(window).height() - 200
        let heightFoto = $(window).height() - 185
        $('.modal-cus-container').width(widthModal)
        $('.modal-cus-body').height(heightBody)
        $('.VueCarousel-inner').height(heightCarousel)
        $('.iiz__img').height(heightFoto)
        self.showSlides(self.slideIndex)
      }, 250)
    },
    plusSlides (n) {
      this.showSlides(this.slideIndex += n)
    },
    currentSlide (n) {
      this.showSlides(this.slideIndex = n)
    },
    showSlides (n) {
      let i
      let slides = document.getElementsByClassName('slides-ora')
      let dots = document.getElementsByClassName('dot-ora')
      if (n > slides.length) {
        this.slideIndex = 1
      }
      if (n < 1) {
        this.slideIndex = slides.length
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = 'none'
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(' active-ora', '')
      }
      slides[this.slideIndex - 1].style.display = 'block'
      dots[this.slideIndex - 1].className += ' active-ora'
    },
    getPoint () {
      this.getPointTracking({ AccountCode: '', TrackingNumber: this.tracking }).then((response) => {
        let point = response
        this.setPoint(point.latitudY, point.longitudX, point.realTimeFlag)
      })
    },
    setPoint (latitudY, longitudX, realTimeFlag) {
      this.order.latitud = latitudY
      this.order.longitud = longitudX
      this.order.realTimeFlag = realTimeFlag === null ? 0 : realTimeFlag
      if (this.order.latitud !== 0 && this.order.longitud !== 0) { this.isPoint = true }

      if (this.order.latitud === 0) { this.order.latitud = this.centerDefault.lat }
      if (this.order.longitud === 0) { this.order.longitud = this.centerDefault.lng }

      this.center = latLng(Number(this.order.latitud), Number(this.order.longitud))

      if (this.isPoint) {
        if (this.order.realTimeFlag === 0) {
          if (this.mobile) {
            this.iconGP = '/static/img/icons/ic_destino_32.png'
            this.iconHE = 28
            this.iconWI = 32
          } else {
            this.iconGP = '/static/img/icons/ic_destino_48.png'
            this.iconHE = 36
            this.iconWI = 48
          }
        } else {
          if (this.mobile) {
            this.iconGP = '/static/img/icons/ic_truck_32.png'
            this.iconHE = 32
            this.iconWI = 32
          } else {
            this.iconGP = '/static/img/icons/ic_truck_48.png'
            this.iconHE = 48
            this.iconWI = 48
          }
        }
      }
      /*
      else {
        if (this.mobile) {
          this.iconGP = '/static/img/icons/ic_dinet_32.png'
        } else {
          this.iconGP = '/static/img/icons/ic_dinet_48.png'
        }
      }
      */
    },
    setOrder (order) {
      this.existe = 1
      this.setActive('track')
      this.order = order
      if (this.order.trackingList != null) {
        if (this.order.trackingList.length > 0) {
          this.eventList = this.order.trackingList[0].eventList
          this.order.tracking = this.order.trackingList[0].trackingNumber
          this.order.realTimeFlag = this.order.trackingList[0].realTimeFlag
          this.order.configuration = this.order.trackingList[0].configuration
          this.order.statusDescription = this.order.trackingList[0].statusDescription
          this.order.latitud = this.centerDefault.lat
          this.order.longitud = this.centerDefault.lng
          let realTimeFlag = this.order.trackingList[0].realTimeFlag

          if (this.eventList != null) {
            if (this.eventList.length > 0) {
              this.eventList.forEach(x => {
                if (x.imageUrl1 !== '' || x.imageUrl2 !== '' || x.imageUrl3 !== '') {
                  x.existImage = true
                } else { x.existImage = false }

                let fotos = []
                if (x.imageUrl1 !== '') {
                  fotos.push(x.imageUrl1)
                }
                if (x.imageUrl2 !== '') {
                  fotos.push(x.imageUrl2)
                }
                if (x.imageUrl3 !== '') {
                  fotos.push(x.imageUrl3)
                }

                x.fotos = fotos
              })
            }
          }

          let event = this.eventList[0]
          this.setPoint(event.latitudY, event.longitudX, realTimeFlag)
        }
      }
    },
    search () {
      document.activeElement.blur()

      this.submitted = true
      if (this.fName !== '' || this.doc !== '') {
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        let filter = {
          AccountCode: '',
          OrderNumber: '',
          TrackingNumber: this.tracking,
          CustomerName: this.fName,
          CustomerDNI: this.doc
        }

        this.getTracking(filter).then((response) => {
          this.submitted = true
          this.loader.hide()

          if (response.order != null) {
            this.setOrder(response.order)
          } else if (response.errorCode > 0) {
            this.existe = 0
          }
        })
      }
    },
    showDetail () {
      this.$modal.show('detail')
    },
    getDetail () {
      let filter = {
        AccountCode: this.account,
        OrderNumber: '', // this.orderNumber,
        TrackingNumber: this.tracking
      }

      this.tableData = {
        data: null
      }

      this.getOrderFollowDetail(filter).then((data) => {
        if (data != null) {
          this.tableData = {
            data: data.orderDetail
          }
          this.tableKey++
        }
      })
    },
    contact () {
      window.open(constants.defaultGeneral.urlHelp, '_blank')
    },
    toDataURL (url) { return fetch(url).then((response) => { return response.blob() }).then(blob => { return URL.createObjectURL(blob) }) },
    async download (images) {
      var a = document.createElement('a')
      a.href = await this.toDataURL(images)
      a.download = 'Image.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  },
  components: {
    Vuetable,
    'inner-image-zoom': InnerImageZoom,
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker,
    'l-icon': LIcon
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
    },
    firstLetter: function (value) {
      if (!value) return ''
      var pieces = value.toString().toLowerCase().split(' ')
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase()
        pieces[i] = j + pieces[i].substr(1)
      }
      return pieces.join(' ')
    },
    minus: function (value) {
      if (!value) return ''
      return value.toString().toLowerCase()
    }
  }
}

</script>
<style>

  @font-face {
    font-family: "Poppins";
    font-weight: 400;
    font-style: normal;
    font-display: auto;
    unicode-range: U+000-5FF;
    src: local("Roboto"), url("/static/Fonts/Poppins/Poppins-Regular.ttf") format("truetype");
  }

  .wrapper
  {
    position: unset !important;
  }

  .nav-tra-order
  {
    height: 60px;
    padding:10px 16px;
    background-color:white;
    display : flex;
    align-items : center;
    justify-content : space-between;
  }  

  .nav-tra
  {
    padding:10px 16px;
    background-color:white;
    display : flex;
    align-items : center;
    justify-content : space-between;
  }

  .container-order
  {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #f9f6f6;
    top: 0;
    left: 0;
    font-family : "Poppins";
    overflow-x: hidden;
    overflow-y: auto;
  }

  .container-tra {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f9f6f6;
    top: 0;
    left: 0;
    font-family : "Poppins"
  }

  .ico-account
  {
    height:35px; 
    padding-left: 80px;
  }

  .label-bold-tra
  {  
    font-weight : 900;
    color: #0C204E;  
  }

  .box-tra {  
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 16px;  
    position: absolute;
    width: 100%;  
    top: -50px;

    /* Color-Fondo/Blanco */
    background: #FFFFFF;
    border-radius: 16px;
    z-index: 999;
  }

  .box-tra-sm {  
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 16px;  
    position: absolute;
    width: 100%;  
    top: 10px;

    /* Color-Fondo/Blanco */
    background: #FFFFFF;
    border-radius: 16px;
  }  

  .card-tra
  {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width:100%;
    padding: 8px 16px;
    margin-top : 14px;    
    background: #FFFFFF;  
    border: 1px solid #DBDFE3;
    border-radius: 16px;  
  }

  .card-header-tra
  {
    width:100%;
    display : flex;
    align-items : center;
    justify-content : space-between;
    height:40px;
  }

  .card-body-tra
  {
    width:100%;
    padding-top: 20px;
    margin-left: 8px;
  }

  .status
  {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background: rgba(0, 162, 255, 0.2);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 900;
    color: #0A74B1;  
  }

  .icon-tracking
  {
    padding: 2px 8px;
    font-size: 20px;
    background: rgba(61, 119, 255, 0.1);
    text-align: center;
    border-radius: 8px;
    color: #3D77FF;
    margin-right: 5px;
  }

  .icon-tracking-img
  {
    filter: brightness(0) saturate(100%) invert(46%) sepia(100%) saturate(3436%) hue-rotate(210deg) brightness(99%) contrast(104%);
  }


  .timeline {  
    margin: 10px 10px 10px 15px;  
    width: 100%;
  }

  .timeline:before {  
    background:white;
  }


  .outer {
    border-left: 2px solid #3D77FF;
  }

  /* Card container */
  .card-tl {  
    position: relative;
    margin: 0 0 0px 20px;     
  }

  .card-lt-title {
    color: #0C204E;
    font-size : 13px;
    font-weight : 900;
    padding-bottom:2px;
    display : flex;
    align-items : center;
    justify-content : space-between;  
  }

  .card-lt-title::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background: #3D77FF;
    border-radius: 999px;
    left: -26px;
    border: 3px solid #3D77FF;
  }

  .card-lt-title:first-child::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 999px;
    left: -26px;
    top: 0px;
    border: 3px solid #3D77FF;
  }


/* Information about the timeline */
  .info {
    display: flex;
    flex-direction: column;
  }

  .arrow-tra
  {
    padding-right: 20px;  
    color: #b5b3b3;
    cursor:pointer;
  }

  .p-tra
  {
    color :#7A859D;
    font-size: 12px;
    padding-bottom : 15px;
  }

  .msg-tra-high
  {
    width : 100%;  
    border-radius: 16px;
    padding: 8px 16px;
    margin-top: 15px;
  }
  
  .msg-tra-high-vacio
  {
    width : 100%;  
    border-radius: 16px;
    padding: 8px 16px;
    margin-top: 15px;
  }

  .msg-tra
  {
    width : 100%;  
    border-radius: 16px;
    padding: 8px 16px;
    margin-top: 15px;
  }

  .msg-tra-vacio
  {
    width : 100%;  
    border-radius: 16px;
    padding: 8px 16px;
    margin-top: 15px;
  }  

  .msg-icono
  {
    background: #FF833E;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    padding: 14px;
    width:75px
  }

  p {
    margin : 0px
  }

  .msg-img
  {
    height:35px;
  }

  .msg-title
  {
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    text-align:center;
  }

  .msg-p
  {
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;  
    text-align:center;
  }

  .data-icon
  {
    font-size:11px;
    margin-right: 13px;
  }

  .data-title
  {
    font-size:12px;
    font-weight: 900;
    color: #0C204E;
  }

  .data-field
  {      
    font-size:12px;
    color: #879BAB;
    padding-left: 35px;
    font-weight: normal;
  }

  .data-space
  {
    padding-bottom: 20px;
  }

  .help-container
  {
    display : flex;
    align-items : center;
    justify-content : center;  
  }

  .help-tra
  {
    width : 100%;  
    border-radius: 16px;
    padding: 5px 16px;
    margin-top: 15px;
    background: #ECF1FF;
  }

  .help-icono
  {    
    display: flex;
    justify-content: right;
    padding: 15px;
    width:50px;
  }

  .help-title
  {  
    padding-top:10px;
    font-size: 12px;  
    text-align:center;
    color: rgba(61, 119, 255, 0.8);
  }

  .help-p
  {
    font-weight: 900;
    font-size: 14px;  
    text-align:center;
    color: #3D77FF;
    text-decoration: underline #3D77FF;
  }

  .a-tra
  {
    color: #3D77FF;
    text-decoration: none;
    font-size:12px;
    cursor: pointer;
  }

  .a-icon
  {
    padding-right:5px;
  }

  .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
      color: #FF7800;
      font-weight:900;
      cursor: default; 
      border: 0px;
      border-bottom: 2px solid #FF7800;    
  }

  .a-tab
  {  
    color:#879BAB;
  }

  .row-button
  {
    position: absolute;
    top: 70px;
    z-index: 1;  
    background-color: transparent;    
    display : flex;
    align-items : center;  
    width:100%;
    justify-content: end;
    padding-right: 50px;
  }

  .ub-icon
  {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(8%) hue-rotate(163deg) brightness(101%) contrast(105%);
  }

  .ub-actual{
    padding: 5px 16px;  
    border-radius: 10px;
    color: white;
    background-color: #FF7800;
    font-size: 11px;
    box-shadow: 0px 2px 4px rgb(76 93 112 / 24%), 0px 0px 1px rgb(76 93 112 / 30%);
    cursor:pointer;
  }

  .back{
    padding: 9px 16px;  
    border-radius: 10px;
    color: white;
    background-color: #FF7800;
    font-size: 11px;
    box-shadow: 0px 2px 4px rgb(76 93 112 / 24%), 0px 0px 1px rgb(76 93 112 / 30%);
    cursor:pointer;
    margin-right: 5px;
  }

  .msg-nf-order
  {
    margin: 20px 20px 20px 90px;
    background-color: white;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #DBDFE3;      
  }  

  .msg-nf
  {
    margin: 20px;
    background-color: white;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #DBDFE3;      
  }

  .title-nf
  {
    color: #FF7800;
    font-size: 24px;
    font-weight: 900;
    margin-top: 20px;
  }

  .p-nf
  {
    padding-top: 20px;
  }

  .img-nf
  {
    max-width:400px;
  }

  .img-event
  {
    height: 100px;
    padding: 5px;
    border-radius: 10px;
    width: 100px;
    cursor: pointer;
  }

  .help-img
  {
    height:43px;
  }

  .btn-ora
  {
    height: 36px;
    color:#ffffff;
    background-color: #FF833E;
    width:100%;
    border-radius: 8px;
  }

  .btn-ora:hover
  {
    background-color: #fb5d05;
    color:#ffffff;
  } 
  
  .btn-ora:active
  {
    background-color: #fb5d05;
    color:#ffffff !important;
  } 
  
  .btn-ora-blue
  {
    height: 24px;
    font-size: 12px;
    color: #ffffff;
    background-color: #5088F8;
    padding: 3px 10px;
    border-radius: 16px;
  }

  .btn-ora-blue:hover
  {
    background-color: #0F59F6;
    color:#ffffff;
  }   
  
  .form-control-ora
  {
    height: 36px !important;
    border-radius: 8px !important;
  }
 
  .form-control-ora:hover
  {
    border: 1px solid #FF833E;    
  }

  .div-ora-flex
  {
    justify-content: space-between;
    align-items: center;
    display: flex;    
  }  

  .table-text-ora {
    vertical-align: middle !important;
    text-transform: none !important;
    color: #0C204E !important;
    font-family: "Poppins" !important;
    padding:16px !important;
  }

  .table-data-ora {
    vertical-align: middle !important;
    text-transform: none !important;
    color:  #879BAB !important;
    font-family: "Poppins" !important;
    padding:16px !important;
    vertical-align:middle;
  }    

  table.tr-ora tr:nth-child(odd) td{
    background:#ffffff !important;
    border: 0px !important;
    
  }
  table.tr-ora tr:nth-child(even) td{
    background:#FAFBFF !important;
    border: 0px !important;
  }  

  .div-left-0
  {
    padding-left: 0px;
  }

  .img-back
  {
    display: flex;
    align-items: center;    
  }

  .modal-ora .v--modal
  {
    border-radius: 16px !important;
  }  
   
  .modal-cus-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-cus-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-cus-container {
    width: 80%;    
    margin: 0px auto;
    padding: 10px 15px;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-cus-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-cus-body {
    margin: 5px 0;
    text-align: center;
  }

  .modal-cus-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-cus-enter {
    opacity: 0;
  }

  .modal-cus-leave-active {
    opacity: 0;
  }

  .modal-cus-enter .modal-cus-container,
  .modal-cus-leave-active .modal-cus-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .button-download
  {
    padding: 5px;
    position: relative !important;
    top: -55px !important;
    right: 5px;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background: rgb(12 12 12 / 20%);
    opacity: 1;
    color: #242423;    
  }

  .div-copy
  {
    background-color: #e7e5e5;
    border-radius: 8px;
    margin-top: 5px;
    padding: 2px;
    font-size: 12px;    
  }

/* Carrusel */

.slides-ora {display: none}
.slides-ora img {vertical-align: middle;}

/* Slideshow container */
.slideshow-container-ora {
  position: relative;
  margin: auto;
}

/* Next & previous buttons */
.prev-ora, .next-ora {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -22px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next-ora {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev-ora:hover, .next-ora:hover {
  background-color: rgba(0,0,0,0.8);
}

/* The dots/bullets/indicators */
.dot-ora {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active-ora, .dot-ora:hover {
  background-color: #FF833E;
}

/* Fading animation */
.fade-ora {
  animation-name: fade-ora;
  animation-duration: 1.5s;
}

@keyframes fade-ora {
  from {opacity: .41} 
  to {opacity: 1}
}

/* On smaller screens, decrease text size */
@media only screen and (max-width: 400px) {
  .prev-ora, .next-ora,.text-ora {font-size: 11px}
}


@media screen and (max-width: 414px) {
  .row {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  .row-button
  {    
    top: 70px;    
    padding-right: 55px;
  } 
  
  .ico-account
  {    
    padding-left: 80px;
  }  

  .nav-tra-order {
    justify-content: end;
  }

  .row-button {
    padding-right: 55px;
  }    

  .box-tra {
    padding: 24px 2px !important;
    top: -20px !important;
  }

  .box-tra-sm {
    padding: 24px 2px !important;
    top: 5px !important;
  }  

  .row-button {
    padding-right: 55px;
  }     

  .msg-tra-high
  {
    position: absolute !important;
    top: -110px !important;    
  }

  .msg-tra-high-vacio
  {
    position: absolute !important;
    top: -80px !important;    
  }

  .msg-tra
  {
    position: absolute !important;
    top: -100px !important;
  }

  .msg-tra-vacio
  {
    position: absolute !important;
    top: -80px !important;
  }  

  .help-icono
  {      
    justify-content: center;
    padding-right: 35px;
    padding-top: 5px;
    padding-bottom: 5px;
  }  

  .help-tra
  {
    padding: 5px 16px; 
  }  

  .msg-title
  {
    font-size: 12px !important;
  }

  .msg-p
  {
    font-size: 12px !important;
    line-height: 14px!important;
  }

  .msg-icono
  {        
    border-radius: 10px!important;
    padding: 8px!important;
    width:60px !important;
  }

  .msg-img
  {
    height:30px !important;
  }

  .data-mob
  {
    padding-left:5px!important;
    padding-right:5px!important;
  }

  .data-space {    
    padding-top: 10px !important;
    border-bottom: 1px solid #DBDFE3 !important;
    padding-bottom: 10px !important;
    margin-left: 0px !important;
  }

  .data-space-border {    
    padding-top: 10px !important;        
    margin-left: 0px !important;
  }  

  .data-icon{
    margin-right: 2px;
  }

  .a-tra
  {
    font-weight:900 !important;
    font-size:14px !important;
  }  

  .ub-actual{
    color: #FF7800;
    background-color: white;
    border-radius : 50%;  
    width: 35px;
    padding: 4px 3px;
    text-align: center;
  }

  .row-ub-actual
  {
    top: 67px;
  }

  .ub-icon
  {
    filter: brightness(0) saturate(100%) invert(43%) sepia(100%) saturate(1269%) hue-rotate(0deg) brightness(102%) contrast(105%);
  }

  .msg-nf-order
  {
    display: block;    
    text-align:center;  
    margin-left: 15px;  
  }  

  .msg-nf {    
    display: block;    
    text-align:center;
  }  

  .img-nf
  {
    max-width:250px;
  }

  .img-event
  {
    width: 90px;
    height: 90px;
  }  

  #fotos .v--modal{
    height: 100% !important;
    width: 90% !important;
    left: 49% !important;
    top:150px !important;
  }  

  #detail .v--modal{
    height: 650px !important;
    width: 370px !important;
    left: 49% !important;
    top:150px !important;
  }  

  .foto-ora {
    height: 100%;
    width: 100%;
  }  

  .img-back
  {
    padding-left: 0px !important;  
  }  

  .modal-cus-container {
    width: 95% !important;
  }
}

@media screen and (max-width: 320px) {
  .row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .label-bold-tra{
    font-size:12px !important;
  }  

  .status{
    font-size:9px !important;
  }

  .card-lt-title
  {
    font-size:11px !important;
  }

  .p-tra
  {
    font-size:10px !important;
  }  

  .box-tra {
    padding: 24px 2px !important;
    top: -20px !important;
  }

  .box-tra-sm {
    padding: 24px 2px !important;
    top: 5px !important;
  }  

  .nav-tabs>li {
    font-size:11px !important;
  }

  .msg-tra-high
  {
    position: absolute !important;
    top: -110px !important;    
  }

  .msg-tra-high-vacio
  {
    position: absolute !important;
    top: -80px !important;    
  }  

  .msg-tra
  {
    position: absolute !important;
    top: -100px !important;
  }

  .msg-tra-vacio
  {
    position: absolute !important;
    top: -80px !important;
  }  

  .help-title
  {
    font-size: 10px;
  }

  .help-p
  {
    font-size: 11px;
  }  

  .help-icono
  {      
    justify-content: center;
    padding-right:10px;
    padding: 5px;
  }  

  .help-img
  {      
    height : 30px !important;
  }  

  .help-tra
  {
    padding: 5px 16px; 
  }  

  .msg-title
  {
    font-size: 10px !important;
  }

  .msg-p
  {
    font-size: 11px !important;
    line-height: 14px!important;
  }

  .msg-icono
  {        
    border-radius: 10px!important;
    padding: 8px!important;
    width:50px !important;
  }

  .msg-img
  {
    height:25px !important;
  }  

  .data-space {    
    padding-top: 10px !important;
    border-bottom: 1px solid #DBDFE3 !important;
    padding-bottom: 10px !important;
    margin-left: 0px !important;
  }

  .data-icon{
    margin-right: 2px;
  }  

  .a-tra
  {
    font-weight:900 !important;
    font-size:12px !important;
  }  

  .ub-actual{
    color: #FF7800;
    background-color: white;
    border-radius : 50%;  
    width: 35px;
    padding: 4px 3px;
    text-align: center;
  }

  .row-ub-actual
  {
    top: 67px;
  }

  .ub-icon
  {
    filter: brightness(0) saturate(100%) invert(43%) sepia(100%) saturate(1269%) hue-rotate(0deg) brightness(102%) contrast(105%);
  }

  .data-icon
  {
    font-size:10px;
  }

  .data-title
  {
    font-size:9px;
  }

  .data-field
  {
    font-size:10px;
  }

  .msg-nf {    
    display: block;    
    text-align:center;
  }  

  .img-nf
  {
    max-width:250px;
  }

  .img-event
  {
    width: 80px;
    height: 80px;
  }  

/*   #fotos .v--modal{
    height: 550px !important;
    width: 310px !important;
    left: 58% !important;    
  }  */

  #detail .v--modal{
    height: 550px !important;
    width: 310px !important;
    left: 58% !important;    
  } 
  
  .modal-cus-container {
    width: 98% !important;
  }  
}

</style>




// WEBPACK FOOTER //
// TrackingNumber.vue?6e0823eb